import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export abstract class ProduktionsmallBaseCommand extends BasicCommand<ProduktionsmallBaseCommand> {
    guid: string;
    benamning: string;
    vardekap: boolean;
    ckLeverantorId?: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Produktionsmall";

    get primaryKey(): IPrimaryKey<IProduktionsmallPrimaryKey> {
        return {
            produktionsmallGuid: this.guid
        };
    }

    constructor($type: string, commandType: CommandType) {
        super($type, ProduktionsmallBaseCommand.$groupKey, commandType);
    }
}

export interface IProduktionsmallPrimaryKey {
    produktionsmallGuid: string;
}
